// @flow
import { TaskProfileReducerState } from 'common/models/internal/TaskProfileReducerState';
import TaskProfileActions from 'common/redux/actions/taskProfile';
import { TaskProfile } from 'common/models/internal/TaskProfile';

const initialState = TaskProfileReducerState.fromJS({});

export default (
    state: TaskProfileReducerState = initialState,
    action: Object
) => {
    switch (action.type) {
        case TaskProfileActions.FETCH_TASK_PROFILE_START:
            return state.setIsLoading(true);

        case TaskProfileActions.FETCH_TASK_PROFILE_ERROR:
            return state.setIsLoading(false);

        case TaskProfileActions.INJECT_TASK_PROFILE: {
            const taskProfile = TaskProfile.fromJS(action.response);
            const { taskProfileId } = action.params;
            const updatedTaskProfileMap = state.taskProfileMap.set(
                taskProfileId,
                taskProfile
            );
            return state
                .setIsLoading(false)
                .setTaskProfileMap(updatedTaskProfileMap);
        }

        default:
            return state;
    }
};
